import React, { FunctionComponent, useEffect, useState } from "react";

export interface TableOfContents {
  items: { id: string; label: string }[];
}

// A heading becomes active once its top passes this far below the viewport top.
const ACTIVE_OFFSET = 120;

export const TableOfContents: FunctionComponent<TableOfContents> = ({
  items,
}) => {
  const [activeId, setActiveId] = useState(items[0]?.id);

  useEffect(() => {
    const update = () => {
      const passed = items.filter(({ id }) => {
        const heading = document.getElementById(id);
        return heading && heading.getBoundingClientRect().top <= ACTIVE_OFFSET;
      });
      setActiveId((passed[passed.length - 1] || items[0])?.id);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, [items]);

  return (
    <nav
      aria-label="On this page"
      className="flex flex-col gap-3 font-display text-ui"
    >
      <div className="text-label font-semibold uppercase text-muted">
        On this page
      </div>
      {items.map(({ id, label }) =>
        id === activeId ? (
          <a
            key={id}
            href={`#${id}`}
            aria-current="location"
            className="border-l-[3px] pl-2.5 font-semibold"
            style={{ borderColor: "var(--topic)" }}
          >
            {label}
          </a>
        ) : (
          <a
            key={id}
            href={`#${id}`}
            className="pl-[13px] text-muted hover:text-spark"
          >
            {label}
          </a>
        )
      )}
    </nav>
  );
};
